import materials from "./materials";
import schedules from "./schedules";

export default {
    materials,
    schedules,
};
